<div class="upload-sidebar">
	<!-- Same bar as the document viewer and the details panel: what this is, and a close. -->
	<header class="up-header">
		<div class="up-header__text">
			<div class="up-header__title">Add an expense</div>
			<div class="up-header__sub">{{ !isLoaded ? (allowMultiple ? 'Upload receipts or bills' : 'Upload a receipt or bill')
				: files.length > 1 ? 'Each document becomes its own expense' : 'Check it is the right file, then submit' }}</div>
		</div>
		<button type="button" class="up-icon-btn" matTooltip="Close" [matTooltipShowDelay]="showToolTipDelay"
			aria-label="Close" (click)="cancel()">
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
		</button>
	</header>

	<div class="up-body" *ngIf="!isLoaded">
		<ngx-file-drop dropZoneClassName="up-drop" contentClassName="up-drop__content" (onFileDrop)="dropped($event)">
			<ng-template ngx-file-drop-content-tmp>
				<div class="up-drop__icon" aria-hidden="true">
					<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
						<path d="M12 16V4"/><path d="M7 9l5-5 5 5"/><path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>
					</svg>
				</div>
				<div class="up-drop__title">Drag &amp; drop {{ allowMultiple ? 'your documents' : 'your document' }} here</div>
				<div class="up-drop__or">or</div>
				<button type="button" class="up-btn up-btn--primary" (click)="filesrc.click()">{{ allowMultiple ? 'Choose files' : 'Choose file' }}</button>
				<div class="up-drop__hint">PDF, PNG or JPG{{ allowMultiple ? ' · several at once is fine' : '' }}</div>
				<input hidden #filesrc type="file" accept=".pdf, .png, .jpg, .jpeg" [multiple]="allowMultiple" (change)="added($event)">
			</ng-template>
		</ngx-file-drop>

		<!-- No document at all: code it by hand. -->
		<section class="up-alt" *ngIf="canCodeManually">
			<button type="button" class="up-alt__item" *ngIf="canCodeManually" (click)="openManualCoding()">
				<span class="up-alt__icon up-alt__icon--green" aria-hidden="true">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>
				</span>
				<span class="up-alt__text">
					<span class="up-alt__title">Code it manually</span>
					<span class="up-alt__desc">No document? Enter the supplier, account and amount yourself.</span>
				</span>
				<svg class="up-alt__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
			</button>
		</section>

		<section class="up-forward" *ngIf="mailboxData?.personalEmail || (mailboxData?.companyEmail && roleId != 3)">
			<div class="up-forward__title">Or forward it by email</div>
			<div class="up-forward__sub">Anything sent to these addresses lands in your Inbox.</div>

			<div class="up-forward__row" *ngIf="mailboxData?.personalEmail">
				<div class="up-forward__text">
					<span class="up-forward__label">My inbox</span>
					<span class="up-forward__email" [title]="mailboxData.personalEmail">{{ mailboxData.personalEmail }}</span>
				</div>
				<button type="button" class="up-icon-btn" matTooltip="Copy address" [matTooltipShowDelay]="showToolTipDelay"
					aria-label="Copy my inbox address" (click)="copyToClipboard(mailboxData.personalEmail)">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/></svg>
				</button>
			</div>

			<div class="up-forward__row" *ngIf="mailboxData?.companyEmail && roleId != 3">
				<div class="up-forward__text">
					<span class="up-forward__label">Company inbox</span>
					<span class="up-forward__email" [title]="mailboxData.companyEmail">{{ mailboxData.companyEmail }}</span>
				</div>
				<button type="button" class="up-icon-btn" matTooltip="Copy address" [matTooltipShowDelay]="showToolTipDelay"
					aria-label="Copy company inbox address" (click)="copyToClipboard(mailboxData.companyEmail)">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/></svg>
				</button>
			</div>
		</section>
	</div>

	<div class="up-body up-body--file" *ngIf="isLoaded">
		<!-- One row per document; with several, clicking a row previews it. -->
		<div class="up-files" [class.up-files--many]="files.length > 1">
			<div class="up-file" *ngFor="let f of files; let i = index" [class.up-file--selected]="files.length > 1 && i === selectedIndex"
				(click)="selectFile(i)">
				<div class="up-file__icon" [class.up-file__icon--pdf]="f.type === 'application/pdf'" aria-hidden="true">{{ f.type === 'application/pdf' ? 'PDF' : 'IMG' }}</div>
				<div class="up-file__text">
					<div class="up-file__name" [title]="f.name">{{ f.name }}</div>
					<div class="up-file__meta">{{ fileSizeLabel(f) }}</div>
				</div>
				<button type="button" class="up-icon-btn up-icon-btn--danger" matTooltip="Remove" [matTooltipShowDelay]="showToolTipDelay"
					[attr.aria-label]="'Remove ' + f.name" (click)="$event.stopPropagation(); removeFile(i)" [disabled]="loading">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M10 11v6M14 11v6"/><path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12"/><path d="M9 7V4h6v3"/></svg>
				</button>
			</div>
		</div>

		<!-- The same viewer controls as everywhere else: click to zoom in, Shift/Alt-click
		     out, Ctrl/Cmd + wheel or pinch to zoom, drag to move the page. -->
		<div class="up-preview">
			<app-pdf-viewer *ngIf="isPdf" [tempFile]="tempFile" [showButtons]=false></app-pdf-viewer>
			<ng-container *ngIf="!isPdf">
				<!-- Only while zoomed: back to the size it opened at. -->
				<button type="button" class="zoom-reset" *ngIf="imageScale !== 100" (click)="imageScale = 100; imagePane.scrollTo(0, 0)"
				        title="Back to the original size">
				  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>
				  <span class="zoom-reset__level">{{ imageScale }}%</span>
				  <span>Reset</span>
				</button>
				<div #imagePane class="up-preview__image" appPanZoom (zoomStep)="zoomImage($event)">
					<img alt="Uploaded document" [src]="tempFile" draggable="false" [style.width.%]="imageScale">
				</div>
			</ng-container>
		</div>
	</div>

	<footer class="up-footer" *ngIf="isLoaded">
		<ng-container *ngIf="allowMultiple; else chooseAnother">
			<button type="button" class="up-btn up-btn--secondary" (click)="moreFiles.click()" [disabled]="loading">Add more</button>
			<input hidden #moreFiles type="file" accept=".pdf, .png, .jpg, .jpeg" multiple (change)="added($event)">
		</ng-container>
		<ng-template #chooseAnother>
			<button type="button" class="up-btn up-btn--secondary" (click)="deleteFile()" [disabled]="loading">Choose another</button>
		</ng-template>
		<button type="button" class="up-btn up-btn--primary up-btn--submit" (click)="save()" [class.loading]="loading" [disabled]="isDisabled">
			<span class="button-text">{{ files.length > 1 ? 'Submit ' + files.length + ' documents' : 'Submit' }}</span>
			<span class="spinner" *ngIf="loading"></span>
		</button>
	</footer>
</div>

<!-- The same dialog as everywhere an expense is coded by hand. It sits over this panel;
     once the expense is handed over, the panel closes with it. -->
<app-expense-modal *ngIf="showManualCoding" (onClose)="onManualCodingClosed($event)"></app-expense-modal>
